import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { UpdateCompanyDto } from '@ansvar-sakerhet/api-client';
import { toast } from '../../../components/Toast';
import { keys } from './company.key';

export function useUpdateCompany() {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const mutationFn = async ({
    companyId,
    data,
  }: {
    companyId: string;
    data: UpdateCompanyDto;
  }) => {
    const api = await getApi();
    const res = await api.companiesUpdate(companyId, data);
    return res.data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.all });
      toast.success('Bolag uppdaterat');
    },
    onError: () =>
      toast.error('Ett fel uppstod när bolaget skulle uppdateras'),
  });
}
